"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = exports.getChartColors = exports.onChangeAttr = exports.changeAttrValue = exports.getAttrValue = exports.reduceSchema = exports.getPrefix = exports.addPrefix = exports.getExistProperty = exports.checkSchema = exports.camel2KebabCase = exports.mergeDeep = exports.isObject = void 0;
const theme_schema_1 = require("./theme-schema");
function isObject(item) {
    return (item && typeof item === 'object');
}
exports.isObject = isObject;
function mergeDeep(...objects) {
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach((key) => {
            const pVal = prev[key];
            const oVal = obj[key];
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat(...oVal);
            }
            else if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
}
exports.mergeDeep = mergeDeep;
const camel2KebabCase = (str) => (str
    .split('')
    .map((letter, idx) => (letter.toUpperCase() === letter && Number.isNaN(+letter) && letter !== '-'
    ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
    : letter))
    .join(''));
exports.camel2KebabCase = camel2KebabCase;
const checkSchema = (schema, defaultColorsSchema) => {
    if (schema)
        return mergeDeep(defaultColorsSchema, schema);
    return defaultColorsSchema;
};
exports.checkSchema = checkSchema;
const getExistProperty = (schema, value) => {
    if (schema[value])
        return `var(--${value})`;
    return value;
};
exports.getExistProperty = getExistProperty;
const addPrefix = (target, prefix) => Object.fromEntries(Object.entries(target).map(([k, v]) => [`${prefix}${k}`, target[v] ? `${prefix}${v}` : v]));
exports.addPrefix = addPrefix;
const getPrefix = (key) => `${(0, exports.camel2KebabCase)(key)}-`;
exports.getPrefix = getPrefix;
const reduceSchema = (schema) => (Object
    .entries(schema)
    .map(([key, value]) => (0, exports.addPrefix)(value, `${(0, exports.getPrefix)(key)}`))
    .reduce((acc, i) => (Object.assign(Object.assign({}, acc), i)), {}));
exports.reduceSchema = reduceSchema;
function getAttrValue(attrName, defaultValue) {
    return (document.documentElement.getAttribute(attrName) || defaultValue);
}
exports.getAttrValue = getAttrValue;
function changeAttrValue(attrName, mode) {
    document.documentElement.setAttribute(attrName, mode);
}
exports.changeAttrValue = changeAttrValue;
function onChangeAttr(attr, cl, defaultValue) {
    const mutationCallback = (callback) => ((mutationsList) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const mutation of mutationsList) {
            if (mutation.type !== 'attributes'
                || mutation.attributeName !== attr) {
                return;
            }
            const target = mutation.target;
            const mode = (target.getAttribute(attr) || defaultValue);
            callback(mode);
        }
    });
    const observer = new MutationObserver(mutationCallback(cl));
    observer.observe(document.documentElement, {
        attributeFilter: [attr],
        attributeOldValue: true,
        attributes: true,
        childList: false,
        subtree: false,
    });
    return () => {
        if (document.documentElement) {
            observer.disconnect();
        }
    };
}
exports.onChangeAttr = onChangeAttr;
const getChartColors = () => (Object.keys(theme_schema_1.themeSchema.defaultSchema.colors)
    .filter((key) => key.includes('chart'))
    .map((s) => (`rgb(var(--colors-${(0, exports.camel2KebabCase)(s)}))` // todo add support hex
)));
exports.getChartColors = getChartColors;
function getColor(color, alpha = 1) {
    const rootStyles = getComputedStyle(document.querySelector(':root'));
    const colorVar = rootStyles.getPropertyValue(`--colors-${color}`);
    const colorArray = colorVar.split(' ').filter((e) => e).map((x) => parseInt(x, 10));
    return `rgba(${colorArray[0]},${colorArray[1]},${colorArray[2]},${alpha})`;
}
exports.getColor = getColor;
//# sourceMappingURL=utils.js.map